import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { login } from './authSlice';

const fieldClass = 'flex flex-col gap-1.5';
const labelClass = 'text-[0.8rem] font-medium text-fg-muted';
const inputClass =
  'w-full rounded-sm border border-line bg-surface-raised px-3.5 py-[11px] text-[0.95rem] text-fg outline-none transition-colors focus:border-accent';

export default function AuthView() {
  const dispatch = useAppDispatch();
  const loginStatus = useAppSelector((state) => state.auth.status);
  const loginError = useAppSelector((state) => state.auth.error);

  // Derived, not state: nothing to synchronise, and no redirect effect either —
  // once auth.token is set the /auth route in App.jsx redirects to /stats.
  const errorMessage = loginStatus === 'failed' && loginError ? loginError : '';

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    dispatch(
      login({
        username: data.get('login'),
        password: data.get('password'),
      }),
    );
  };

  const isLoading = loginStatus === 'loading';

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-bg p-6">
      <form
        className="flex w-full max-w-[380px] flex-col gap-3.5 rounded-lg border border-card-line border-t-card-line-top bg-card px-7 py-8 shadow-soft"
        onSubmit={handleSubmit}
      >
        <div className="text-lg font-bold tracking-[-0.01em] text-fg">
          OCTAGON<span className="text-accent">.</span>
        </div>
        <h1 className="mt-1.5 text-2xl leading-tight font-semibold tracking-[-0.02em] text-fg">
          Sign in
        </h1>
        <p className="mb-1.5 text-sm text-fg-muted">Use your Octagon credentials to continue.</p>

        {errorMessage && (
          <div
            role="alert"
            className="rounded-sm border border-danger-line bg-danger-soft px-3 py-2.5 text-[0.85rem] text-danger"
          >
            {errorMessage}
          </div>
        )}

        <label className={fieldClass}>
          <span className={labelClass}>Login</span>
          <input
            className={inputClass}
            required
            id="login"
            name="login"
            autoComplete="username"
            autoFocus
          />
        </label>

        <label className={fieldClass}>
          <span className={labelClass}>Password</span>
          <input
            className={inputClass}
            required
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
          />
        </label>

        <button
          type="submit"
          disabled={isLoading}
          className="mt-2 rounded-sm bg-fg px-4 py-3 text-[0.95rem] font-semibold text-bg transition-opacity disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isLoading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
